import React from 'react';
import { IconButton } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import CloseIcon from '@mui/icons-material/Close';
import PhoneIcon from '@mui/icons-material/Phone';

import useWindowStyles from 'components/CallScribe/Window/windowStyles';

export interface IWindowHeaderProps {
  variant: 'ticket' | 'call';
  onGround?: boolean;
  title: string;
  subtitle?: string;
  onBack: () => void;
  onClose: () => void;
}

const WindowHeader: React.FC<IWindowHeaderProps> = ({
  variant,
  onGround = false,
  title,
  subtitle,
  onBack,
  onClose,
}) => {
  const classes = useWindowStyles();

  return (
    <div className={onGround ? `${classes.header} ${classes.headerOnGround}` : classes.header}>
      {variant === 'call' ? (
        <IconButton size="small" aria-label="Back to ticket" onClick={onBack}>
          <ArrowBackIosNewIcon fontSize="small" />
        </IconButton>
      ) : (
        <span className={classes.headerMark}>
          <PhoneIcon fontSize="small" />
        </span>
      )}
      <span className={classes.headerTitles}>
        <span className={classes.headerTitle}>{title}</span>
        {subtitle !== undefined && subtitle.length > 0 ? (
          <span className={classes.headerSubtitle}>{subtitle}</span>
        ) : null}
      </span>
      <IconButton size="small" aria-label="Close CallScribe" onClick={onClose}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </div>
  );
};

export default WindowHeader;
